import { createContext, useContext, type ReactNode } from 'react';

/** `editor` is the authoring canvas. `export` is the document HTML that must match React-PDF. */
export type DocumentSurface = 'editor' | 'export';

const DocumentSurfaceContext = createContext<DocumentSurface>('editor');

export interface DocumentSurfaceProviderProps {
  surface: DocumentSurface;
  children: ReactNode;
}

export function DocumentSurfaceProvider({ surface, children }: DocumentSurfaceProviderProps) {
  return <DocumentSurfaceContext.Provider value={surface}>{children}</DocumentSurfaceContext.Provider>;
}

export function useDocumentSurface(): DocumentSurface {
  return useContext(DocumentSurfaceContext);
}
